import { getUrlPrefix } from '../locales'

// this prefix is all urls, and so put the lang prefix after and the rest of the url
const PREFIX = '/_/fallback'
export function langFallbackFetch(
  langCode: string,
  url: string,
  init?: RequestInit,
) {
  const langPrefix = getUrlPrefix(langCode)
  return fetch(`${PREFIX}${langPrefix}${url}`, init)
}

export function getLangFallbackUrl(langCode: string, url: string) {
  const langPrefix = getUrlPrefix(langCode)
  return `${PREFIX}${langPrefix}${url}`
}

export function getDomainName() {
  return window.location.hostname
}
